// 'use server'

export default async function handleUploadApi({ data, onProgress = null }) {
  const resp = await (
    await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST.replace("/u", "")}/uploads`,
      {
        method: "POST",
        headers: {
          // 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        onUploadProgress: (event) => {
          const percent = Math.floor((event.loaded / event.total) * 100);
          // setProgress(percent);
          // if (percent === 100) {
          //   setTimeout(() => setProgress(0), 1000);
          // }
          if (onProgress) {
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        },
        body: data,
      },
    )
  ).json();
  return resp?.data;
}
